'use client';

import { CopyRights, HeaderHeroSection } from '@/components/static';
import { useOIDCAuth } from '@/hooks/oidc';
import { LayoutSectionWrapper } from '@/layout/LayoutSectionWrapper';
import { SectionWithNavigation } from '@/layout/SectionWithNavigation';
import { MainPageConfig } from '@/types/ssr';
import { T } from '@/utils/common';

import s from './styles.module.scss';
import { makeMainPageUnits } from './utils';
type MainPageProps = {
  pageConfig: MainPageConfig;
};

export function MainPage({ pageConfig }: MainPageProps) {
  const { content, TOC } = makeMainPageUnits(pageConfig);
  useOIDCAuth(true);

  return (
    <>
      <div className={s.hero_wrapper}>
        <LayoutSectionWrapper>
          <HeaderHeroSection />
        </LayoutSectionWrapper>
      </div>
      <div className={s.main_wrapper}>
        <SectionWithNavigation getActiveElementParentIdsPred={T} TOCList={TOC} TOCClassName={s.TOC_wrapper}>
          <div className={s.main}>
            {content}
            <CopyRights />
          </div>
        </SectionWithNavigation>
      </div>
    </>
  );
}
